type LabelProps = {
  children?: React.ReactNode;
  text?: string;
};

export const Label = ({ children, text }: LabelProps) => {
  return (
    <p className="p-caption">
      {children}
      <b>{text}</b>
    </p>
  );
};
